module.exports = __webpack_public_path__ + "static/media/Remember Me.5a0d9aaf.jpg";